import Table from "../../../../components/stateful/table/Table";
import { useUserSubManagementController } from "./UserSubManagementController";

const UserSubManagement = () => {
  
  const {
    activeUsers,
    loading,
    columns,
    deactivate
  } = useUserSubManagementController();


  return (
    <Table 
      values={activeUsers} 
      columns={columns} 
      tableName={"Active Subscription Users"} 
      height={"70svh"}
      isLoading={loading}
      onButtonClick={deactivate}
      buttonText="Deactivate"
      notFilterable
      notPageable
      notSortable
    />
  )
}

export default UserSubManagement;